import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import Carousel from "react-multi-carousel";
import { Link } from "gatsby";
import tekBannerPoster from "../../images/home-update/video-banner/home-banner-poster.webp";
import tekBannerMp4 from "../../images/home-update/video-banner/home-banner.mp4";
import tekBannerWebm from "../../images/home-update/video-banner/home-banner.mp4";

import {
  HomeBannerFeaturedForbes,
  HomeBannerFeaturedInc,
  HomeBannerFeaturedYEC,
  Feature4,
  Feature5,
  Feature6,
  Feature7,
  Feature8,
  HomeBannerFeaturedEnt,
} from "../../../app-constants";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1600 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1599, min: 1400 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1399, min: 1200 },
    items: 4,
  },
  tabletlandscape: {
    breakpoint: { max: 1199, min: 768 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 767, min: 576 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 575, min: 0 },
    items: 2,
  },
};

function VideoBanner({ handleShow }) {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);
  const sectionRef = useRef(null);

  // useEffect(() => {
  //   const handleUserInteraction = () => {
  //     setUserInteracted(true);
  //   };

  //   document.addEventListener('click', handleUserInteraction);
  //   document.addEventListener('touchstart', handleUserInteraction);

  //   return () => {
  //     document.removeEventListener('click', handleUserInteraction);
  //     document.removeEventListener('touchstart', handleUserInteraction);
  //   };
  // }, []);

  useEffect(() => {
    const handleUserInteraction = () => {
      setUserInteracted(true);
    };

    const interactionEvents = [
      "click",
      "mousemove",
      "touchstart",
      "keydown",
      "scroll",
      "mouseover",
    ];

    interactionEvents.forEach((event) =>
      document.addEventListener(event, handleUserInteraction)
    );

    return () => {
      interactionEvents.forEach((event) =>
        document.removeEventListener(event, handleUserInteraction)
      );
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && userInteracted) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [userInteracted]);

  return (
    <>
      <section class="tekrevol__videobanner overflow-x-hidden">
        <StaticImage
          src="../../images/business-plan-workshop/banner-image.png"
          alt="Master the Art of Business Planning"
          className="banner-image"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={1914}
          height={782}
        />

        <Container>
          <Row>
            <Col
              xs={12}
              md={9}
              lg={9}
              xl={8}
              xxl={7}
              className="mt-auto mb-auto"
            >
              <div className="bann-cont">
                <h1>
                  <span>From Idea to Impact</span>
                </h1>
                <h2>
                  Building Your <span>Business</span> Blueprint
                </h2>
                <p>
                  Join our exclusive workshop on{" "}
                  <strong style={{ color: "#f47a14" }}>
                    Tuesday, 03rd December
                  </strong>{" "}
                  led by {""}
                  <strong>Irfan ul Haq, COO of TekRevol,</strong>
                  with 20+ years of experience in business operations. Learn the
                  secrets to creating a winning business plan!
                  <br className="d-xl-block d-none" />
                </p>
                <Link
                  href="https://www.tekrevol.com/blogs/business-plan-workshop-registration/"
                  className="btn-pri"
                  onClick={handleShow}
                >
                  Reserve My Spot Now!
                </Link>
              </div>
              <div className="desktop_view">
                <div className="feat">
                  <div className="feat-wrap">
                    <div className="title">Featured In</div>
                  </div>
                  <div className="feature-list">
                    <div className="featured_item">
                      <div className="featured_img">
                        {HomeBannerFeaturedInc}
                      </div>
                    </div>

                    <div className="featured_item">
                      <div className="featured_img">
                        {HomeBannerFeaturedForbes}
                      </div>
                    </div>

                    <div className="featured_item">
                      <div className="featured_img">
                        {HomeBannerFeaturedYEC}
                      </div>
                    </div>
                    <div className="featured_item">
                      <div className="featured_img">
                        {HomeBannerFeaturedEnt}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xs={12}
              md={5}
              lg={5}
              xl={5}
              xxl={5}
              className="mt-auto mb-auto"
            ></Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default VideoBanner;
